module.exports = __webpack_public_path__ + "img/JAOC_POP_AgedCheese_oval.da9ed666.png";